import { Map } from 'immutable';

import { TeamId } from 'app/lib/betting/constants';

const TENNIS_GAMES_SCORES = [0, 15, 30, 40];
const SCORE_BEFORE_GAME_END = 3;
export const SCORE_AMOUNT_FOR_TIE_BREAK = 6;

type FormatMapValue = number | 'A';

type Format = Map<TeamId, FormatMapValue>;

function convertTennisGameScore(score: number) {
  if (score < 0) {
    return NaN;
  }

  return TENNIS_GAMES_SCORES[score] ?? TENNIS_GAMES_SCORES[TENNIS_GAMES_SCORES.length - 1];
}

export const formatTennisGameScores = (gameScores: Map<number, number>): Format => {
  const firstScore = gameScores.get(TeamId.FIRST) || 0;
  const secondScore = gameScores.get(TeamId.SECOND) || 0;

  if (
    firstScore >= SCORE_BEFORE_GAME_END
    && secondScore >= SCORE_BEFORE_GAME_END
    && firstScore !== secondScore
  ) {
    return (firstScore > secondScore)
      ? Map<TeamId, FormatMapValue>([
        [TeamId.FIRST, 'A'],
        [TeamId.SECOND, convertTennisGameScore(secondScore)],
      ])
      : Map<TeamId, FormatMapValue>([
        [TeamId.FIRST, convertTennisGameScore(firstScore)],
        [TeamId.SECOND, 'A'],
      ]);
  }

  return gameScores.map(convertTennisGameScore);
};
